export const AUTO_ADJUSTMENT_RULES_QUERY_KEY = 'AUTO_ADJUSTMENT_RULES_QUERY_KEY';
export const AUTO_ADJUSTMENT_RULE_QUERY_KEY = 'AUTO_ADJUSTMENT_RULE_QUERY_KEY';
